/* eslint-disable class-methods-use-this */

import React, {Component} from 'react';
import LoginForm from '../login-form';
import './login.css';
import LoginBackground from '../../../assets/img/login_bg.png';

class Login extends Component {
  render() {
    return (
      <div className="login-outer-container">
        <div className="login-container">
          <LoginForm/>
          <div className="welcome-image-container">
            <img
              src={LoginBackground}
              className="welcome-image"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/login-page/index.jsx